import React from 'react';
import { Partner, PartnerStatus, PartnerStatusUpdate } from '@marageti/z4-sdk/lib/travel';
import {
  useContextMenu, useApiClient, useFetchImmutable, useFetch,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { enqueueSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import PartnerSecondaryAppbarView from './partner-sub-navigation-view';
import { TabItem } from '../sub-navigation/types';

const PARTNER_LINKS: TabItem[] = [
  {
    label: 'profile',
    to: '',
  },
  {
    label: 'trips',
    to: 'trip-matches',
  },
  {
    label: 'reviews',
    to: 'reviews',
  },
  {
    label: 'tickets',
    to: 'tickets',
  },
  {
    label: 'people',
    to: 'people',
  },
  {
    label: 'Invoice',
    to: 'invoice',
  },
  {
    label: 'reports',
    to: 'reports',
  },
  {
    label: 'settings',
    to: 'settings',
  },
];

const PartnerSubNavigationContainer = () => {
  const { partnerId } = useParams();
  const apiClient = useApiClient();
  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();
  const { data: partner, mutate } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], true);

  const onClickNewStatus = (status: PartnerStatus) => {
    if (partner) {
      apiClient.partnersClient.putPartnerStatus(partner.id, { id: partner.id, status } as PartnerStatusUpdate)
        .then(() => {
          mutate();
          enqueueSnackbar('Partner status updated.', { variant: 'success' });
        })
        .catch(() => {
          enqueueSnackbar('Failed to update partner status.\nPlease try again in a few minutes.', { variant: 'default', style: { backgroundColor: 'red' } });
        })
        .finally(() => {
          setContextMenuAnchor(null);
        });
    }
  };
  return (
    <PartnerSecondaryAppbarView
      tabs={PARTNER_LINKS}
      contextMenuAnchor={contextMenuAnchor}
      contextMenuOpen={contextMenuOpen}
      countryCodes={countryCodes}
      onClickNewStatus={onClickNewStatus}
      setContextMenuAnchor={setContextMenuAnchor}
      partner={partner}
    />
  );
};

export default PartnerSubNavigationContainer;
